export var groupNamesByWrapping = {
    horizontal: 'Row',
    vertical: 'Column',
    none: 'VirtualRow',
};
